import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-use';
import BannerImg from '../../../../public/assets/images/BannersFiles/22.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import { PageHitCountApi } from '../../../shared/Helper';

const Darmhamd = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { pathname } = useLocation();
  const { t } = useTranslation();
  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);
  return (
    <>
        <StaticBanner BannerImg={BannerImg} en_US={'Dirham Al Hamd'} arabic={false} />
      <div className="py-5">
        <section
          className={`px-10 sm:h-90 flex xl:flex-row flex-col items-center sm:px-20 ${isActive ? 'text-left' : 'text-right'}`}>
          <img src={`/assets/images/1234.png`} className="pb-4 md:max-w-screen-sm" alt="" />
          <div className="xl:px-10 flex flex-col justify-center items-center h-full  lg:pb-0">
            <h4
              className={`text-customgreen  flex sm:text-2xl items-center text-justify leading-10`}>
              {isActive
                ? ` هي خدمة تبرعات متميزة ومستحدثة تم إطلاقها تحت مسمى "درهم الحمد" لتفتح المجال أمام الراغبين في التبرع بمبلغ درهم واحد يوميا كصدقة تتوزع عبر 17 صنف من مشاريع الصدقة العامة. صدق رسول الله صلى الله عليه وسلم الذي قال "سبق درهم مائة ألف".`
                : `The "Dirham Al Hamd" is a unique and innovative donation service launched to allow individuals to donate one dirham daily as charity distributed across 17 categories of general charity projects. As the Prophet Muhammad (PBUH) said, "A dirham has outstripped a hundred thousand dirhams."`}
            </h4>
            <Link to={'https://campaigns.shjc.ae/hamd/'} target="_blank" >
              <button
                type="submit"
                className="text-white mx-1 lg:mt-3 bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-3 py-2.5 text-center">
                {t('Service Procedure')}
              </button>
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};
export default Darmhamd;
